import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Branch } from 'src/app/services/branch/branch.model';

import { BranchService } from 'src/app/services/branch/branch.service';
import { setAddressForGoogleMaps as setAddress } from 'src/app/helpers/google-maps-search.helper';

@Component({
  selector: 'app-branch-info',
  templateUrl: './branch-info.component.html',
  styleUrls: ['./branch-info.component.scss'],
})
export class BranchInfoComponent implements OnInit, OnDestroy {
  branch: Branch | null = null;
  setGoogleMapsSearch = setAddress;

  private subscriptions: Array<Subscription> = [];

  constructor(private branchService: BranchService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.branchService.selectedBranch.subscribe((data: Branch | null) => {
        this.branch = null;

        if (data) {
          this.branch = { ...data };
        }
      })
    );
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
